import { Type } from 'class-transformer'
import { Room } from './Device/Room'
import { Router } from './Device/Router'

export class Device {

  public readonly id: string

  @Type(() => Room)
  public readonly rooms: Room[]

  @Type(() => Router)
  public readonly router: Router|null

  constructor(id: string, rooms: Room[], router?: Router) {
    this.id = id
    this.rooms = rooms
    this.router = router
  }
}
